import { FC } from 'react';
import { SinglePrint, SinglePrintProps } from "./SinglePrintComponent"

interface SingleTablePrintProps {
    label: string;
    tableId: string;
    data: Array<SinglePrintProps>; 
}

const SingleTablePrint: FC<SingleTablePrintProps> = (props) => {
    
    return(
        <div className="detail-horaire-field">
            <div className="details-label">
                <strong className="bold-text">{props.label}</strong>
            </div>
            <div className="jours">
                {props.data.map((row, index ) => <SinglePrint key={props.tableId + index} label={row.label} data={row.data} isWorkRegimeRow={true}/>)}
            </div>
        </div>
    );
}

export default SingleTablePrint;